import type { ReactNode } from "react";

import { sitePath, useSiteConfig } from "../hooks/use-site-config";
import { GoLink } from "./go-link";
import { SiteFooter } from "./site-footer";
import { siteVars } from "./site-theme";
import { m } from "@/paraglide/messages.js";

/** The closing band every page ends on: two words, as loud as the page gets. */
const Closing = () => {
  const { slug } = useSiteConfig();

  return (
    <div className="mt-16 rounded-[40px] bg-primary px-5 py-20 text-center text-primary-foreground md:mt-[104px] md:py-[120px]">
      <h2 className="text-[clamp(3.5rem,10vw,10.5rem)] leading-[0.9] font-semibold tracking-[-0.06em]">
        {m.landing_close_title()}
      </h2>
      <GoLink to={sitePath(slug)} hash="times" tone="ink" className="mt-10 h-14 px-8 text-base">
        {m.landing_close_cta()}
      </GoLink>
    </div>
  );
};

/**
 * One public page: the head, the wide content column, the closing band and the footer. `head` is
 * the navigation plus whatever the page opens with.
 */
export const SitePage = ({ head, children }: { head: ReactNode; children: ReactNode }) => (
  <div style={siteVars} className="min-h-svh bg-page-background p-3 text-sm text-foreground">
    <div className="mx-auto max-w-[1416px]">
      {head}
      <main>
        {children}
        <Closing />
      </main>
      <SiteFooter />
    </div>
  </div>
);
